import { render, staticRenderFns } from "./VolNewsList.vue?vue&type=template&id=01476723"
import script from "./VolNewsList.vue?vue&type=script&lang=js"
export * from "./VolNewsList.vue?vue&type=script&lang=js"
import style0 from "./VolNewsList.vue?vue&type=style&index=0&id=01476723&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports